module.exports = __webpack_public_path__ + "img/f4@2x.966d44fb.png";